import React from "react";
import { makeStyles, Button, Box } from "@material-ui/core";
import AA from "../assets/images/AA.jpg";
import { TextField } from "formik-material-ui";
import { Field, Form, Formik } from "formik";
import { useHistory } from "react-router-dom";
import ErrorModal from '../components/reusableComponents/ErrorModal'
import SuccessModal from '../components/reusableComponents/SuccessModal'
import LoadingModal from '../components/reusableComponents/LoadingModal'
import { useDispatch } from "react-redux";
import { toggleChangeLogoModal } from "../reducers/UiReducer";
import { agentloginDispatch, agentSignupDispatch } from "../reducers/UserReducer";
const useStyles = makeStyles((theme) => ({
  selectField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #959595",
      },
    },
    backgroundColor: "white",
    marginBottom: 5,
    width: "100%",
    borderRadius: 25,
    [theme.breakpoints.down("xs")]: {
      marginBottom: 5,
      // marginTop: 8,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 5,
      marginBottom: 16,
    },
  },
  InputPropsStyle: {
    backgroundColor: "white",
    borderRadius: 25,
  },
  inputPropsStyle: {
    padding: 14,
  },
  createButton: {
    backgroundColor: "#ee8622",
    color: "white",
    borderRadius: 2,
    width: "100%",
    padding: "11px 8px",
    "&:hover": {
      backgroundColor: "#39c9bb",
    },
  },
}));
const LoginForm = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [tabvalue, setValue] = React.useState(0);
  console.log("tab>>",tabvalue)
  const handleFormSubmit = (data, actions) => {
    if(tabvalue===0){
      console.log("data",data)
      dispatch(agentloginDispatch(data,history))
    }else if(tabvalue===1){
      let formData = {
        userTitle: 'Mr',
        userFirstName: data.userFirstName,
        userLastName: data.userFirstName,
        userPhone: data.userPhone,
        userEmail: data.userEmail,
        password: data.password,
        confirmpassword: data.password,
      };
      console.log("formData",formData)
      dispatch(agentSignupDispatch(formData))
    }
    
  };
  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
      }}
      validate={(values) => {
        const errors = {};
        return errors;
      }}
      onSubmit={handleFormSubmit}
    >
      {({ submitForm, isSubmitting, values, errors }) => (
        <>
          <Form>
            <>
              <Box
                onClick={() => history.push("/")}
                style={{ cursor: "pointer" }}
              >
                <img src={'https://www.amug.com/wp-content/uploads/2016/09/you-logo-here.png'} style={{ height: 60 }}></img>
                {/* <span
                  style={{
                    color: "#8b0000f2",
                    fontSize: "30px",
                    fontWeight: 600,
                    fontFamily: "cursive",
                  }}
                >
                  Arya Aviation
                </span> */}
              </Box>
              {tabvalue === 0 && (
                <>
                  <p
                    style={{
                      color: "#000",
                      fontSize: 20,
                      marginBottom: 20,
                      marginTop: 10,
                    }}
                  >
                    Login
                  </p>
                  <Field
                    // style={{ marginTop: 60 }}
                    component={TextField}
                    name="username"
                    autocomplete="off"
                    type="email"
                    variant="outlined"
                    label="Email ID"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 14, fontSize: 14 },
                    }}
                  />
                  <Field
                    // style={{ marginTop: 60 }}
                    component={TextField}
                    autocomplete="off"
                    name="password"
                    type="password"
                    variant="outlined"
                    label="Password"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 14, fontSize: 14 },
                    }}
                  />
                  <Button
                    className={classes.createButton}
                    onClick={submitForm}
                    style={{ marginTop: 5, fontSize: 14 }}
                    // disabled={isSubmitting}
                  >
                    LOGIN
                  </Button>
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: 15,
                    }}
                  >
                    <p style={{cursor:'pointer'}} onClick={async () => {
									await setValue(2);
									// validateForm(values);
								}}>Forgot Password?</p>
                    <p style={{cursor:'pointer'}}  onClick={async () => {
									await setValue(1);
									// validateForm(values);
								}}>Register Now</p>
                  </Box>
                </>
              )}
              {tabvalue===1&&  <>
                  <p
                    style={{
                      color: "#000",
                      fontSize: 20,
                      marginBottom: 20,
                      marginTop: 10,
                    }}
                  >
                    Registration
                  </p>
                  <Field
                    // style={{ marginTop: 60 }}
                    component={TextField}
                    name="email"
                    autocomplete="off"
                    type="email"
                    variant="outlined"
                    label="Company Name"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 14, fontSize: 14 },
                    }}
                  />
                  <Field
                    // style={{ marginTop: 60 }}
                    component={TextField}
                    name="userFirstName"
                    autocomplete="off"
                    type="text"
                    variant="outlined"
                    label="Name"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 14, fontSize: 14 },
                    }}
                  />
                   <Field
                    // style={{ marginTop: 60 }}
                    component={TextField}
                    name="userEmail"
                    autocomplete="off"
                    type="email"
                    variant="outlined"
                    label="Email"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 14, fontSize: 14 },
                    }}
                  />
                   <Field
                    // style={{ marginTop: 60 }}
                    component={TextField}
                    name="userPhone"
                    autocomplete="off"
                    type="number"
                    variant="outlined"
                    label="Phone"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 14, fontSize: 14 },
                    }}
                  />
                   <Field
                    // style={{ marginTop: 60 }}
                    component={TextField}
                    name="password"
                    autocomplete="off"
                    type="password"
                    variant="outlined"
                    label="Password"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 14, fontSize: 14 },
                    }}
                  />
                  <Button
                    className={classes.createButton}
                    onClick={submitForm}
                    style={{ marginTop: 5, fontSize: 14 }}
                    // disabled={isSubmitting}
                  >
                    REGISTER
                  </Button>
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: 15,
                    }}
                  >
                    <p style={{cursor:'pointer'}} onClick={async () => {
									await setValue(0);
									// validateForm(values);
								}}>Already have an account? Log In</p>
                  </Box>
                </>}
                {tabvalue === 2 && (
                <>
                  <p
                    style={{
                      color: "#000",
                      fontSize: 20,
                      marginBottom: 20,
                      marginTop: 10,
                    }}
                  >
                    Forgot Password
                  </p>
                  <Field
                    // style={{ marginTop: 60 }}
                    component={TextField}
                    name="email"
                    autocomplete="off"
                    type="email"
                    variant="outlined"
                    label="Email"
                    className={classes.selectField}
                    InputProps={{
                      className: classes.InputPropsStyle,
                    }}
                    inputProps={{
                      style: { padding: 14, fontSize: 14 },
                    }}
                  />
                  <Button
                    className={classes.createButton}
                    onClick={() => history.push("/fd")}
                    style={{ marginTop: 5, fontSize: 14 }}
                    // disabled={isSubmitting}
                  >
                    FORGOT PASSWORD
                  </Button>
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: 15,
                    }}
                  >
                    <p style={{cursor:'pointer'}}onClick={async () => {
									await setValue(0);
									// validateForm(values);
								}}>Already have an account? Log In</p>
                  </Box>
                </>
              )}
            </>
          </Form>
          <ErrorModal/>
          <SuccessModal/>
          <LoadingModal/>
        </>
      )}
    </Formik>
  );
};

export default LoginForm;
